import { Switch } from '@audio-network/componentlibrary'
import { Explicit } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'
import React, { FormEvent } from 'react'
import { useToggleRefinement } from 'react-instantsearch'

import styles from './ExplicitFilter.module.css'

const ExplicitFilter = (): JSX.Element => {
	const { t } = useTranslation(['search'])

	const { value, refine } = useToggleRefinement({
		attribute: 'Explicit',
		on: false,
	})

	const toggleExplicit = (event: FormEvent): void => {
		refine({ isRefined: !(event.target as HTMLInputElement).checked })
	}
	return (
		<Switch
			checked={value.isRefined}
			className={styles.switch}
			data-testid="explicit-switch"
			label={
				<>
					{t('hide-explicit')}
					<Explicit data-testid="explicit-icon" />
				</>
			}
			onChange={toggleExplicit}
		/>
	)
}

export default ExplicitFilter
